
function PokemonImage({poke, name}){
    
    return(
        <img src={poke} alt={name}/> 
    )
}

export default PokemonImage


